import SectionBanner from "../sections/services/SectionBanner";
import SectionCategories from "../sections/services/SectionCategories";
import SectionServicesInfo from "../sections/services/SectionServicesInfo";
import SectionContact from "../sections/inicio/contact/SectionContact";
const Servicios = () => {
  return (
    <div>
      <SectionBanner />
      <SectionCategories />
      <SectionServicesInfo />
      <SectionContact />
    </div>
  );
};
export default Servicios;
